export const DEMO_COMPANY_MANAGEMENT = 'demo-company-management'

export const NEW_DEMO_COMPANY = `${DEMO_COMPANY_MANAGEMENT}/create`

/** Returns the browser path for viewing a specific demo company. */
export const demoCompanyViewPath = (id: string): string =>
  `${DEMO_COMPANY_MANAGEMENT}/${id}/view`

/** Returns the browser path for editing a specific demo company. */
export const demoCompanyEditPath = (id: string): string =>
  `${DEMO_COMPANY_MANAGEMENT}/${id}/edit`
